import baseRequester, { createRequestHeaders } from '@zg-rentals/particles-js-requester';

type Requester = typeof baseRequester;

export const requester: Requester = 'default' in baseRequester ? (baseRequester.default as Requester) : baseRequester;

export { createRequestHeaders };
